(function () {
    window.addEventListener('load', function () {
        /* polyfill for IE11 */
        var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

        /* Main Header object with shared functions and classes */
        var Header = {
            classes: {
                FADED_CLASS: 'is-faded',
                ACTIVE_CLASS: 'active',
                WHITE_STYLE_MENU_CLASS: 'navigationWhite',
                NAVIGATION_BIG_MENU_CLASS: 'header.big-menu',
                NAVIGATION_CLASS: 'header.big-menu nav',
                NAVIGATION_MENU_CLASS: 'header.big-menu .menu',
                NAVIGATION_LEVEL1_ITEMS_CLASS: 'header.big-menu nav > ul > li.sub-menu',
                NAVIGATION_LEVEL3_CLASS: 'header.big-menu nav ul.level-3',
                NAVIGATION_LEVEL2_CLASS: 'header.big-menu nav ul.level-2',
                NAVIGATION_LEVEL2_ITEMS_CLASS: 'header.big-menu .level2-wrapper > ul > li',
                NAVIGATION_SEARCH_LABEL_CLASS: '.sub-menu__label'
            },
            closeMainMenu: function () {
                var base = document.querySelector(Header.classes.NAVIGATION_MENU_CLASS);
                //close Main menu by unchecking the level-1 input field
                var level1InputState = base.querySelectorAll('input[name="megaMenuState"]:checked');
                if (level1InputState.length > 0) {
                    level1InputState[0].checked = false;
                }
            },
            closeOnClickOutside: function (event) {
                var nav = document.querySelector(Header.classes.NAVIGATION_MENU_CLASS);
                //if menu doesn't contain event.target close the menu
                var target = nav.contains(event.target);

                if (!target) {
                    Header.closeMainMenu();
                }
            },
            unselectMenuItemState: function () {
                var labels = document.querySelectorAll(Header.classes.NAVIGATION_SEARCH_LABEL_CLASS);
                // clicking on labels if menu is opened (radio  checked) then we close the menu.
                Array.prototype.forEach.call(labels, function (element) {
                    element.addEventListener('click', function (event) {
                        event.preventDefault();
                        var radio = event.target.parentNode.querySelector('input');
                        radio.checked ? Header.closeMainMenu() : radio.checked = true;
                    });
                });
            },
            mapLevel2ListItems: function (callback) {
                //loop level-2 list items
                var items = document.querySelectorAll(Header.classes.NAVIGATION_LEVEL2_ITEMS_CLASS);
                Array.prototype.forEach.call(items, callback);
            },
            mapLevel2Menu: function (callback) {
                //loop level-2 UL menu
                var items = document.querySelectorAll(Header.classes.NAVIGATION_LEVEL2_CLASS);
                Array.prototype.forEach.call(items, callback);
            },
            mapMainMenuItems: function (callback) {
                //loop level-1 list items
                var items = document.querySelectorAll(Header.classes.NAVIGATION_LEVEL1_ITEMS_CLASS);
                Array.prototype.forEach.call(items, callback);
            }
        };

        /* Marketing Header */
        var MarketingMenu = _extends({}, Header, {
            initLeve2Menus: function () {
                // set first level-2 menu item to active(checked)
                this.mapLevel2Menu(function (element) {
                    var inputState = element.querySelectorAll('input');
                    var activeElements = element.querySelectorAll('input:checked');    
                    
                    if (inputState.length > 0 && activeElements.length === 0) {
                        // if there is no active page then set first item with sub-items to active
                        inputState[0].checked = true;
                    }
                });
            },
            setActiveLink: function () {
                const allLinkInMenu = document.querySelectorAll(this.classes.NAVIGATION_BIG_MENU_CLASS + ' .level-1 a[href]');
                const pageUrl = location.pathname;
                const pageHost = location.host;
                const veluxRED = '#e00';
                let isLinkFound = false;

                // Find link to make it active - BE shouldn't do that
                Array.from(allLinkInMenu).forEach(link => {
                    let linkHref = link.getAttribute('href');
                    let hrefStrings = linkHref.split(pageHost);
                    let bareURL = hrefStrings[hrefStrings.length - 1];

                    if (bareURL.includes('?')) bareURL = bareURL.split('?')[0];
                    if (bareURL.includes('#')) bareURL = bareURL.split('#')[0];

                    if (pageUrl !== '/' && bareURL.toLowerCase() === pageUrl.toLowerCase() && !isLinkFound) {
                        isLinkFound = true;
                        // Highlight the link with red in case it's not a button
                        if (!link.parentElement.classList.contains('button')) link.style.color = veluxRED;

                        let children, menuLabel, parentMainMenu;
                        let parentMenu = link.closest('li.sub-menu');

                        if (parentMenu) {
                            // If the link is under level 3 in the megamenu right column 
                            if (parentMenu.parentElement.classList.contains('level-2')) {
                                
                                children = parentMenu.children;
                                menuLabel = Array.from(children).find(el => el.nodeName === 'LABEL');

                                if (menuLabel) {
                                    // Highlight the level-2 parent with red and set the related input checked
                                    document.getElementById(menuLabel.htmlFor).checked = true;
                                    menuLabel.style.color = veluxRED;

                                    // Find and set the level-1 parent
                                    parentMainMenu = parentMenu.parentElement.closest('li.sub-menu');
                                }
                            } else {
                                // Find and set the level-1 parent in case we have standalone link in the megamenu left column
                                parentMainMenu = parentMenu.closest('li.sub-menu');
                            } 

                            // Highlight the level-1 parent with red
                            if (parentMainMenu) {
                                children = parentMainMenu.children;
                                menuLabel = Array.from(children).find(el => el.classList.contains('sub-menu__label'));

                                if (menuLabel) {
                                    menuLabel.style.color = veluxRED;
                                }
                            }
                        } 
                    }
                });

                this.initLeve2Menus();
            },
            init: function () {
                var menu = document.querySelectorAll(this.classes.NAVIGATION_BIG_MENU_CLASS);
                var nav = document.querySelector(this.classes.NAVIGATION_CLASS);

                if (menu.length === 0 || nav.classList.contains(this.classes.WHITE_STYLE_MENU_CLASS)) { return; }

                window.addEventListener('click', this.closeOnClickOutside.bind(this), false); // close menu if clicked outside of menu or select
                this.setActiveLink(); // sets active radio states and color active links
                this.unselectMenuItemState(); // close menu if it's opened
            }
        });


        /* VELUX.COM White-style menu */
        var ComSiteMenu = _extends({}, Header, {
            fadeSubMenuItemsOnInit: function () {
                //add FADE_CLASS to level2 menu item's except active element
                this.mapLevel2ListItems(function (element) {
                    if (!element.classList.contains(this.classes.ACTIVE_CLASS)) {
                        element.classList.add(this.classes.FADED_CLASS);
                    }
                }.bind(this));
            },
            fadeSubMenuItems: function (event) {
                var nav = document.querySelector(this.classes.NAVIGATION_CLASS);
                if (nav.classList.contains(this.classes.WHITE_STYLE_MENU_CLASS)) {
                    //add to all elements FADE_CLASS and remove ACTIVE_CLASS(so after hovering other elements we can show current level-3 menu)
                    this.mapLevel2ListItems(function (element) {
                        element.classList.add(this.classes.FADED_CLASS);
                        element.classList.remove(this.classes.ACTIVE_CLASS);
                    }.bind(this));
                    //Remove to current target FADE_CLASS
                    event.target.parentNode.classList.remove(this.classes.FADED_CLASS);
                }
            },
            fadeOutSubMenuItems: function () {
                var nav = document.querySelector(this.classes.NAVIGATION_CLASS);
                if (nav.classList.contains(this.classes.WHITE_STYLE_MENU_CLASS)) {
                    //if mouse leave is detected from level-2 list items remove FADE_CLASS from all elements
                    this.mapLevel2ListItems(function (element) {
                        element.classList.remove(this.classes.FADED_CLASS);
                    }.bind(this));
                }
            },
            init: function () {
                var menu = document.querySelectorAll(this.classes.NAVIGATION_BIG_MENU_CLASS);
                var nav = document.querySelector(this.classes.NAVIGATION_CLASS);

                if (menu.length === 0 || !nav.classList.contains(this.classes.WHITE_STYLE_MENU_CLASS)) { return; }

                //Add fade class on level-2 items if it's not active
                this.mapLevel2ListItems(function (element) {
                    element.addEventListener('mouseover', this.fadeSubMenuItems.bind(this));
                    element.addEventListener('mouseleave', this.fadeOutSubMenuItems.bind(this));
                }.bind(this));

                this.fadeSubMenuItemsOnInit();

                window.addEventListener('click', this.closeOnClickOutside.bind(this), false); // close menu if clicked outside of menu or select
                this.unselectMenuItemState(); // close menu if it's opened
            }
        });

        MarketingMenu.init();
        ComSiteMenu.init();

        /* Additional menu features */

        detectIframeClicks();
        function detectIframeClicks() {
            var iframes = document.querySelectorAll('iframe');

            var elementToExclude = document.querySelector(".read-more-block iframe");
            var iframeEnter = false;
            Array.prototype.filter.call(iframes, function (elem) {
                return elem !== elementToExclude;
            }).forEach(function (iframe) {
                iframe.addEventListener('mouseover', function () {
                    iframeEnter = true;
                });
                iframe.addEventListener('mouseout', function () {
                    iframeEnter = false;
                });
            });

            window.addEventListener('blur', function () {
                if (iframeEnter) {
                    document.querySelector('body').click();                   
                }
            });
        }

    }, false);
})();